import Swiper, { Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'

const setItemActive = (list, target, isActive) => {
  if (isActive) {
    target.classList.add('is-active')
    target.setAttribute('aria-expanded', true)
  }

  list.forEach((item) => {
    if (!isActive || item !== target) {
      item.classList.remove('is-active')
      item.setAttribute('aria-expanded', false)
    }
  })
}

const init = (wrapper) => {
  const inner = wrapper.querySelector('.js-map-hotspots-inner')
  const markers = wrapper.querySelectorAll('.js-map-hotspots-marker')
  const closeButtons = wrapper.querySelectorAll('.js-map-hotspots-card-close')
  const hideCarouselButton = wrapper.querySelector('.js-map-hotspots-hide-carousel-button')
  const carousel = wrapper.querySelector('.js-map-hotspots-carousel')
  let swiper
  let isClickingButton = false

  const handleMarkerClick = (targetMarker, updateCarousel = true) => {
    const isActive = !targetMarker.classList.contains('is-active')

    setItemActive(markers, targetMarker, isActive)
    inner.classList.toggle('is-active', isActive)

    if (updateCarousel) {
      swiper.slideTo(targetMarker.dataset.carouselIndex)
    }
  }

  const hideDetails = () => {
    setItemActive(markers, null, false)
    inner.classList.remove('is-active')
  }

  markers.forEach((marker, index) => {
    marker.setAttribute('data-carousel-index', index)
    marker.addEventListener('click', () => {
      isClickingButton = true
      handleMarkerClick(marker)
    })
  })

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener('click', hideDetails)
  })

  hideCarouselButton.addEventListener('click', hideDetails)

  swiper = new Swiper(carousel, {
    modules: [
      Pagination
    ],
    cssMode: false,
    slidesPerView: 'auto',
    centeredSlides: true,
    speed: 600,
    pagination: {
      el: carousel.querySelector('.swiper-pagination'),
      clickable: true
    }
  })

  swiper.on('slideChange', function () {
    if (!isClickingButton) {
      const marker = wrapper.querySelector(`.js-map-hotspots-marker[data-carousel-index="${swiper.realIndex}"]`)

      if (marker) {
        handleMarkerClick(marker, false)
      }

    }

    isClickingButton = false
  })
}

export default () => {
  document.querySelectorAll('.js-map-hotspots').forEach((wrapper) => {
    if (!wrapper.classList.contains('is-initialized')) {
      wrapper.classList.add('is-initialized')
      init(wrapper)
    }
  })
}
